import { Component, OnInit, ViewChild, ViewEncapsulation  } from '@angular/core'
import { locale as en } from '../i18n/en'
import { locale as fr } from '../i18n/fr'
import { locale as de } from '../i18n/de'
import { locale as pt } from '../i18n/pt'
import { CoreTranslationService } from '@core/services/translation.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CoreConfigService } from '@core/services/config.service';
import { ColumnMode, DatatableComponent, id } from '@swimlane/ngx-datatable';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router'
import { ApiService } from 'app/main/services/Api/api.service'
import { HttpErrorResponse } from '@angular/common/http'
import { ToastService } from 'app/main/services/Toast/toast.service'
import { ExcelService } from 'app/services/Excel/excel.service'

@Component({
  selector: 'app-organizers',
  templateUrl: './organizers.component.html',
  styleUrls: ['./organizers.component.scss']
})
export class OrganizersComponent implements OnInit {

  public contentHeader: object

  /**
   *
   * @param {CoreTranslationService} _coreTranslationService
   */
  constructor(private _coreTranslationService: CoreTranslationService,
    private modalService: NgbModal,private router: Router,
    private api: ApiService,public toastService: ToastService,private excelService: ExcelService
  ) {
    this._coreTranslationService.translate(en, fr, de, pt)
  }

  // Lifecycle Hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */

  ngOnInit() {
    this.api.showAllOrganizers(1,100).subscribe({
      next: (response) => {
        console.log(response.data)
        this.rows = response.data.map( (item,index)=>({
          id: item.id,
          '#': index + 1,
          email: item.email,
          nameAr: item.nameAr,
          nameEn: item.nameEn,
          numOfEventsOrganized: item.numOfEventsOrganized,
          organizedEvents: item.organizedEvents,
          phoneNumber: item.phoneNumber,
          profilePicture: item.profilePicture,
        }))
        this.temp = this.rows
      }, error: (error: HttpErrorResponse) => {
        console.log(error)
      }
    })

    this.columns = [
      {
        prop: 'selected',
        name: '',
        sortable: false,
        canAutoResize: false,
        draggable: false,
        resizable: false,
        headerCheckboxable: true,
        checkboxable: true,
        width: 50
      },
      { prop: '#' },
      { name: 'اسم المشرف', prop: 'nameAr' },
      { name: 'البريد الالكتروني', prop: 'email' },
      { name: 'عدد الفعاليات الكلية', prop: 'numOfEventsOrganized' },
      { name: '', prop: '' },
    ]

    this.temp = this.rows

    document.getElementById('الرئيسية')?.classList.remove('active')
    document.getElementById('الفعاليات')?.classList.remove('active')
    document.getElementById('المستخدمين')?.classList.remove('active')
    document.getElementById('طلبات المشرفين')?.classList.remove('active')
    document.getElementById('فئات المناسبات')?.classList.remove('active')
    // document.getElementById('الإشعارات')?.classList.remove('active')
    document.getElementById('المسئولين')?.classList.remove('active')

    this.contentHeader = {
      headerTitle: 'المشرفين',
      actionButton: false
    }
  }

  
  // table setup
  public readonly pageLimitOptions = [
    {value: 5},
    {value: 10},
    {value: 25},
    {value: 50},
    {value: 100},
  ];
  public chkBoxSelected = [];
  public currentVisible: number = 3;
  public currentPageLimit: number = 10;
  rows = [];
  temp = [];
  @ViewChild(DatatableComponent) public table: DatatableComponent;
  ColumnMode = ColumnMode;
  columns = []
  customChkboxOnSelect({ selected }) {
    this.chkBoxSelected.splice(0, this.chkBoxSelected.length);
    this.chkBoxSelected.push(...selected);
  }
  updateFilter(event: any) {
    const val = event?.target?.value ? event.target.value.toLowerCase() : '';
  
    // Filter data by checking all columns
    const temp = this.temp.filter((row) => {
      return Object.keys(row).some((key) => 
        row[key]?.toString().toLowerCase().includes(val)
      );
    });
  
    // Update the rows
    this.rows = temp;
    console.log(temp)
    // Reset to first page
    if (this.table) {
      this.table.offset = 0;
    }
  }
  public onLimitChange(limit: any): void {
    this.changePageLimit(limit);
    this.table.limit = this.currentPageLimit;
    this.table.recalculate();
    setTimeout(() => {
      if (this.table.bodyComponent.temp.length <= 0) {
        // TODO[Dmitry Teplov] find a better way.
        // TODO[Dmitry Teplov] test with server-side paging.
        this.table.offset = Math.floor((this.table.rowCount - 1) / this.table.limit);
        // this.table.offset = 0;
      }
    });
  }
  private changePageLimit(limit: any): void {
    this.currentPageLimit = parseInt(limit, 10);
  }
  public onVisibleChange(visible: any): void {
    this.currentVisible = parseInt(visible, 10);
  }
  modalOpenDefault(modalDefault) {
    this.modalService.open(modalDefault, {
      centered: true
    });
  }
  modalOpenLG(modalLG) {
    this.modalService.open(modalLG, {
      centered: true,
      size: 'lg'
    });
  }
  deletedItemId: any
  deleteItem(id: number) {
    console.log("Deleted Item ID:", id);
    this.deletedItemId = id; // Store ID for further actions
  }
  confirmDeleteItem(){
    if(this.deletedItemId){
      this.api.deleteOrganizer(this.deletedItemId).subscribe({
        next: (response) => {
          if(response.success == true){
            console.log(response)
            this.toastService.show('تم حذف المشرف بنجاح ✅');
            setTimeout(() => {
              window.location.reload()
            }, 2000);
          }
        }, error: (error: HttpErrorResponse) => {
          const errorMessage = error.error?.message || 'حدث خطأ أثناء حذف المشرف ❌';
          this.toastService.show(errorMessage);
        }
      })
    }
  }

  newEvent(){
    this.router.navigate(['/new-org']);
  }

  assignToEvent(){
    this.router.navigate(['/assign-event']);
  }

  eventsOrganizer: any
  continuesEvents: any
  continuesEventsLenght: number = 0
  endedEvents: any
  endedEventsLenght: number = 0
  getEvents(id){
    if(id){
      this.api.showEventOrganizer(id,1,100).subscribe({
        next: (response) => {
          this.eventsOrganizer = response.data
          console.log(this.eventsOrganizer)
          const now = new Date();
          // Separate events based on whether ANY schedule's endTime is in the future
          this.continuesEvents = this.eventsOrganizer.filter(event => 
          new Date(event.endTime) > now
        );
        this.continuesEventsLenght = this.continuesEvents.length;
        
        // Filter events where endTime is in the past (ended events)
        this.endedEvents = this.eventsOrganizer.filter(event => 
          new Date(event.endTime) <= now
        );
        this.endedEventsLenght = this.endedEvents.length;
        
        console.log("Ongoing Events:", this.continuesEvents);
        console.log("Ended Events:", this.endedEvents);
          // console.log(this.eventsOrganizer)
        }, error: (error: HttpErrorResponse) => {
          console.log(error)
        }
      })
    }
  }

  // download files
  downloadFile(file: string){
    if(file == 'pdf'){
      let tableHTML = `
        <html>
          <head>
            <title>Table Export</title>
            <style>
              table { width: 100%; border-collapse: collapse; font-size: 14px; direction: rtl; }
              th, td { border: 1px solid black; padding: 8px; text-align: center; }
              th { background-color: #f2f2f2; }
            </style>
          </head>
          <body>
            <h2 style="text-align:center;">تقرير المشرفين</h2>
            <table>
              <thead>
                <tr>
                  ${Object.keys(this.rows[0]).map(header => `<th>${header}</th>`).join("")}
                </tr>
              </thead>
              <tbody>
                ${this.rows.map(row => `
                  <tr>
                    ${Object.keys(row).map(key => `<td>${row[key].toString().replace(/<[^>]*>/g, '')}</td>`).join("")}
                  </tr>
                `).join("")}
              </tbody>
            </table>
          </body>
        </html>
      `;

      const newWindow = window.open("", "_blank");
      newWindow?.document.write(tableHTML);
      newWindow?.document.close();
      newWindow?.print();
    }else if(file == 'excel'){
      if (!this.rows || this.rows.length === 0) {
        alert("لا توجد بيانات للتصدير!");
        return;
      }
    
      let csvContent = "\uFEFF"; // UTF-8 BOM for Arabic compatibility
    
      // Extract column headers dynamically from the first row
      const headers = Object.keys(this.rows[0]); 
      csvContent += headers.join(",") + "\n";
    
      // Add Table Rows
      this.rows.forEach(row => {
        const rowData = headers.map(header => {
          let cell = row[header] ? row[header].toString() : '';
          return `"${cell.replace(/"/g, '""').replace(/<[^>]*>/g, '')}"`; // Escape quotes & remove HTML
        }).join(",");
        csvContent += rowData + "\n";
      });
    
      // Create a Download Link
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.setAttribute("download", "organizers.csv");
      document.body.appendChild(link);
    
      // Trigger Click
      link.click();
      document.body.removeChild(link);
    }
  }

  export(){
    const headers = {
      nameAr: 'اسم المشرف',
      email: 'البريد الالكتروني',
      numOfEventsOrganized: 'عدد الفعاليات الكلية'
    };
    this.excelService.exportExcel('تقرير المشرفين',this.rows,headers)
  }
}

